import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import { widget } from "../../Assets/charting_library/charting_library.min";
import * as Stomp from "stompjs";
import * as SockJS from "sockjs-client";
import { Modal } from "react-bootstrap";
import InfoPopUp from "../../Common/InfoPopUp";
import { OptionDataContenxt } from "./OptionChartDashboard";
import { showToast } from "../../CoreDataService";
import InfoIcon from "@mui/icons-material/Info";

const title = "Chart Widget";
const description =
  "Displays trade chart for 1 minute,3 minutes, 5 minutes, 15 minutes, 30 minutes, 1 hour, 4 hours, 1 day, 2 days, 3 days, 1 week, 3 weeks, 1 month, 6 months, and years as well.";

const OptionTVChart = () => {
  const { currencycode, basecurrency, assetpair } =
    useContext(OptionDataContenxt);
  const logo = localStorage.getItem("exchangeLogo");
  const [show, setShow] = useState(false);
  const [symbol, setSymbol] = useState(assetpair);
  const [interval, setInterval] = useState("60");
  const [datafeedUrl, setDatafeedUrl] = useState(
    "https://accounts.paybito.com/ChartApi/options"
  );
  const [libraryPath, setLibraryPath] = useState("/charting_library/");
  const [chartsStorageUrl, setChartsStorageUrl] = useState(
    "https://saveload.tradingview.com"
  );
  const [chartsStorageApiVersion, setChartsStorageApiVersion] = useState("1.1");
  const [clientId, setClientId] = useState("tradingview.com");
  const [userId, setUserId] = useState(localStorage.getItem("uuid"));
  const [fullscreen, setFullscreen] = useState(false);
  const [autosize, setAutosize] = useState(true);
  const [containerId, setContainerId] = useState("tv_chart_container");
  const [tvWidget, setTvWidget] = useState(null);
  const [Themecolor, setThemecolor] = useState(localStorage.getItem("theme"));
  const [currency, setCurrency] = useState("");
  const [isLoading, setLoading] = useState(false);
  const handleClose = () => setShow(false);

  const websocketRef = useRef(null);

  // Store the realtime callback from subscribeBars
  const realtimeCallbackRef = useRef(null);
  const lastBarRef = useRef(null);

  const webSocketEndPoint =
    "https://options-socket.paybito.com/OptionChartStream/ws";
  const topic = "/user/topic/stream/tradingView";

  const reqNoRef = useRef(null);
  const intervalRef = useRef("60");

  let stompClient = null;
  let buyingAsset = currencycode;
  let sellingAsset = basecurrency;

  const connectWebSocket = () => {
    console.log("Attempting to connect to WebSocket...");
    if (websocketRef.current?.socket) {
      console.log("WebSocket already connected.");
      return;
    }
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      const ws = new SockJS(webSocketEndPoint);
      stompClient = Stomp.over(ws);
      stompClient.debug = null; // Disable debug logging

      stompClient.connect(
        {},
        (frame) => {
          console.log("WebSocket Connected Successfully");

          websocketRef.current.socket = stompClient;

          if (currencycode && basecurrency) {
            stompClient.subscribe(topic, (sdkEvent) => {
              onMessageReceived(sdkEvent);
            });

            // Ensure subscription happens only after WebSocket is ready
            subscribe();
          }
        },
        errorCallback
      );
    }
  };

  const errorCallback = (error) => {
    console.error("WebSocket Error:", error);
    if (localStorage.getItem("access_token")) {
      setTimeout(() => {
        connectWebSocket();
      }, 5000);
    }
  };

  const sendMessage = (message) => {
    if (stompClient && stompClient.connected) {
      let sendEndpoint = "/app/sendRequest/tradingView";

      stompClient.send(sendEndpoint, {}, JSON.stringify(message));
    } else {
      console.warn("WebSocket not connected yet, retrying...");
      setTimeout(() => sendMessage(message), 1000);
    }
  };

  // Updated function to properly update the chart
  const updateRealtimeBar = (data) => {
    if (!realtimeCallbackRef.current) {
      console.log("Realtime callback not ready");
      return;
    }

    try {
      const bar = {
        time: Number(data.t[0]) * 1000,
        open: Number(data.o[0]),
        high: Number(data.h[0]),
        low: Number(data.l[0]),
        close: Number(data.c[0]),
        volume: Number(data.v[0]) * 0.7,
      };

      // Check if this is a new bar or update to existing bar
      if (lastBarRef.current && bar.time === lastBarRef.current.time) {
        // Update existing bar - merge high/low
        bar.high = Math.max(bar.high, lastBarRef.current.high);
        bar.low = Math.min(bar.low, lastBarRef.current.low);
        bar.open = lastBarRef.current.open; // Keep original open
      }

      lastBarRef.current = bar;

      console.log("Updating chart with bar:", bar);
      realtimeCallbackRef.current(bar);
    } catch (error) {
      console.error("Error updating realtime bar:", error);
    }
  };

  const onMessageReceived = (message) => {
    try {
      const parsedMessage = JSON.parse(message.body);
      console.log("parsedMessage", parsedMessage);
      changeMessage(parsedMessage);
    } catch (error) {
      console.error("Error parsing WebSocket message:", error);
    }
  };

  const changeMessage = (obj) => {
    console.log("Received Message:", obj);
    if (obj && obj.t && obj.o && obj.h && obj.l && obj.c && obj.v) {
      updateRealtimeBar(obj);
    }
  };

  const mapResolution = (res) => {
    const resolutionMap = {
      "1": "1MIN", "3": "3MIN", "5": "5MIN", "15": "15MIN", "30": "30MIN",
      "60": "1HR", "240": "4HR",
    };
    return resolutionMap[res] || res;
  };

  const subscribe = (resolution) => {
    const res = resolution || intervalRef.current;
    if (buyingAsset && sellingAsset) {
      reqNoRef.current = Math.floor(Math.random() * 1000) + 1;
      const req = {
        method: "SUBSCRIBE",
        base: basecurrency,
        counter: currencycode,
        contract: assetpair,
        actualResolution: mapResolution(res),
        id: reqNoRef.current,
      };
      setTimeout(() => {
        sendMessage(req);
      }, 10000);

      localStorage.setItem("isUnsubscribeOccured", "false");
    }
  };

  const unsubscribe = () => {
    if (buyingAsset && sellingAsset && reqNoRef.current != null) {
      const req = {
        method: "UNSUBSCRIBE",
        base: basecurrency,
        counter: currencycode,
        contract: assetpair,
        actualResolution: mapResolution(intervalRef.current),
        id: reqNoRef.current,
      };

      sendMessage(req);
      localStorage.setItem("isUnsubscribeOccured", "true");
    }
  };

  const disconnectWebSocket = () => {
    if (stompClient && stompClient.connected) {
      console.log("Disconnecting WebSocket...");
      stompClient.disconnect(() => {
        console.log("WebSocket Disconnected");
        if (websocketRef.current) {
          websocketRef.current.socket = null;
        }
      });
    } else {
      console.warn("WebSocket is not connected, skipping disconnect.");
    }
  };

  const saveChartState = (widget) => {
    if (!widget) return;
    const chartKey = `tvChartOptions_${userId}_${assetpair}`;
    widget.save((state) => {
      localStorage.setItem(chartKey, JSON.stringify(state));
      localStorage.setItem(`tvChartOptions_${userId}_lastSaved`, chartKey);
      console.log("Chart state saved to localStorage");
    });
  };

  const loadChartState = (widget, callback) => {
    if (!widget) return;
    const chartKey = `tvChartOptions_${userId}_${assetpair}`;
    const savedState = localStorage.getItem(chartKey);

    if (savedState) {
      try {
        widget.load(JSON.parse(savedState));
        console.log("Chart state loaded from localStorage");
        if (callback) callback();
      } catch (err) {
        console.error("Error loading saved chart state:", err);
        if (callback) callback();
      }
    } else if (callback) callback();
  };

  // Create Datafeed to properly use refs
  const createDatafeed = () => ({
    onReady: (cb) =>
      setTimeout(
        () =>
          cb({
            supported_resolutions: [
              "1",
              "3",
              "5",
              "15",
              "30",
              "60",
              "240",
              "1D",
              "2D",
              "3D",
              "1W",
              "3W",
              "1M",
              "6M",
            ],
          }),
        0
      ),
    searchSymbols: async (
      userInput,
      exchange,
      symbolType,
      onResultReadyCallback
    ) => {},
    resolveSymbol: async (
      symbolName,
      onSymbolResolvedCallback,
      onResolveErrorCallback
    ) => {
      const split_data = symbolName.split(/[:/]/);
      const symbol_stub = {
        name: symbolName,
        description: `${split_data[1]?.toUpperCase()}`,
        type: "crypto",
        session: "24x7",
        timezone: "Etc/UTC",
        ticker: symbolName,
        exchange: split_data[0],
        minmov: 1,
        pricescale: 100,
        has_intraday: true,
        intraday_multipliers: ["1", "60"],
        supported_resolutions: [
          "1",
          "3",
          "5",
          "15",
          "30",
          "60",
          "240",
          "1D",
          "2D",
          "3D",
          "1W",
          "3W",
          "1M",
          "6M",
        ],
        volume_precision: 8,
        full_name: "full_name",
        listed_exchange: "listed_exchange",
      };
      setTimeout(() => onSymbolResolvedCallback(symbol_stub), 0);
    },
    getBars: async (
      symbolInfo,
      resolution,
      from,
      to,
      onHistoryCallback,
      onErrorCallback,
      firstDataRequest
    ) => {
      try {
        const response = await axios.get(
          `${datafeedUrl}/history?symbol=${assetpair}&resolution=${resolution}&from=${from}&to=${to}`
        );

        if (response.data && response.data.c && response.data.c.length > 0) {
          const bars = response.data.c.map((c, i) => ({
            close: c,
            high: response.data.h[i],
            low: response.data.l[i],
            open: response.data.o[i],
            time: response.data.t[i] * 1000,
            volume: response.data.v[i] * 0.7,
          }));

          // Store the last bar for real-time updates
          if (bars.length > 0) {
            lastBarRef.current = bars[bars.length - 1];
          }

          onHistoryCallback(bars, { noData: false });
        } else {
          onHistoryCallback([], { noData: true });
        }
      } catch (error) {
        console.error("Error fetching bars:", error);
        onHistoryCallback([], { noData: true });
      }
    },
    subscribeBars: (
      symbolInfo,
      resolution,
      onRealtimeCallback,
      subscriberUID,
      onResetCacheNeededCallback
    ) => {
      console.log("subscribeBars called, storing callback");
      // Store the callback to be used when WebSocket data arrives
      realtimeCallbackRef.current = onRealtimeCallback;
    },
    unsubscribeBars: (subscriberUID) => {
      console.log("unsubscribeBars called");
      realtimeCallbackRef.current = null;
      lastBarRef.current = null;
    },
    calculateHistoryDepth: (resolution) => {
      if (resolution === "1D" || resolution === "3D") {
        return { resolutionBack: "M", intervalBack: 6 };
      }
      return parseInt(resolution) < 60
        ? { resolutionBack: "D", intervalBack: 1 }
        : undefined;
    },
  });

  useEffect(() => {
    setLoading(true);

    // Reset refs on asset change
    realtimeCallbackRef.current = null;
    lastBarRef.current = null;

    if (tvWidget) {
      tvWidget.remove();
    }

    const initializeChart = () => {
      const widgetOptions = {
        symbol: `:${assetpair}`,
        datafeed: createDatafeed(),
        interval: "60",
        container_id: containerId,
        library_path: libraryPath,
        locale: "en",
        disabled_features: [
          "header_compare",
          "header_symbol_search",
          "widget_logo",
        ],
        enabled_features: [
          "hide_left_toolbar_by_default",
          "header_indicators",
          "header_chart_type",
          "save_chart_properties_to_local_storage",
          "header_saveload",
        ],
        client_id: clientId,
        user_id: userId,
        fullscreen,
        autosize,
        auto_save_delay: 5,
        theme: Themecolor,
        overrides: {
          "paneProperties.background":
            Themecolor === "dark" ? "#131722" : "#fafafa",
          "paneProperties.vertGridProperties.color":
            Themecolor === "dark" ? "#242323" : "#dedede",
          "paneProperties.horzGridProperties.color":
            Themecolor === "dark" ? "#242323" : "#dedede",
          "symbolWatermarkProperties.transparency": 90,
          "scalesProperties.textColor": "#AAA",
          "mainSeriesProperties.candleStyle.wickUpColor": "#21CB80",
          "mainSeriesProperties.candleStyle.wickDownColor": "#F5475D",
        },
      };

      const newTvWidget = new widget(widgetOptions);
      newTvWidget.onChartReady(() => {
        loadChartState(newTvWidget);

        newTvWidget.headerReady().then(() => {
          const saveButton = newTvWidget.createButton();
          saveButton.textContent = "Save Layout";
          saveButton.addEventListener("click", () => {
            saveChartState(newTvWidget);
            showToast("success", "Chart layout saved!");
          });
        });

        newTvWidget
          .chart()
          .onIntervalChanged()
          .subscribe(null, (newInterval) => {
            unsubscribe();
            intervalRef.current = newInterval;
            setInterval(newInterval);
            subscribe(newInterval);
          });

        setLoading(false);
      });
      setTvWidget(newTvWidget);

      websocketRef.current = {
        socket: null,
      };

      connectWebSocket();
    };

    initializeChart();

    return () => {
      console.log("Cleaning up WebSocket before reconnecting...");
      realtimeCallbackRef.current = null;
      lastBarRef.current = null;
      disconnectWebSocket();
    };
  }, [assetpair]);

  return (
    <div style={{ position: "relative" }}>
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "101%",
            background:
              Themecolor === "light" ? "rgb(250, 250, 250)" : "#2f3241",
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "5px",
          }}
        >
          <div className="img text-center">
            <img className="loadImg" src={logo} height={45} alt="broker_logo" />
            <h3 style={{ fontSize: "14px", color: "#fff" }} className="mt-3">
              Loading...
            </h3>
          </div>
        </div>
      )}
      {!isLoading && (
        <div
          className="group-wWM3zP_M-"
          style={{
            color: "#a8a1a1",
            cursor: "pointer",
            marginTop: "4px",
            left: "367px",
            position: "absolute",
            height: "40px",
            borderRight: "1.5px solid rgb(74 76 79 / 60%)",
            paddingRight: "8px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <InfoIcon className="group-wWM3zP_M-" onClick={() => setShow(true)} />
        </div>
      )}
      <div
        id={containerId}
        style={{
          height: "402px",
          background: Themecolor === "dark" ? "#2f3241" : "rgb(232 233 236)",
          padding: "4px 0 0 0px",
          borderRadius: "5px",
        }}
      ></div>
      <InfoPopUp
        open={show}
        onClose={handleClose}
        title={title}
        description={description}
      />
    </div>
  );
};

export default OptionTVChart;
